<template>
    <div class="project-edit-bar">
        <template v-for="(button, index) of options">
            <span 
            class="edit-button" 
            :class="{'pre-split': button.preSplit && index > 0, disabled: selectCount > 1 && !button.multiSelect}" 
            :key="index"
            @click="onButtonClick(button)"
            >{{$t(button.label)}}</span>
        </template>
    </div>
</template>
<script>
export default {
    name: "project-edit-bar",
    props: {
        selectCount: {
            type: Number,
            default: 0
        },
        options: {
            type: Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            lockButton: false
        }
    },
    methods: {
        onButtonClick(item){
            const isDisabled = this.selectCount > 1 && !item.multiSelect;
            if(isDisabled){
                return;
            }
            this.$emit('handleEdit', item)
        }
    }
}
</script>
<style lang="scss">
.project-edit-bar{
    width: 100%;
    height: 72px;
    line-height: 72px;
    font-size: 0;
    background: #333333;
    padding: 0 26px 0 36px;
    .edit-button{
        display: inline-block;
        height: 36px;
        line-height: 34px;
        font-size: 13px;
        color: #ffffff;
        border-radius: 3px;
        border: solid 1px rgba(255, 255, 255, 0.5);
        padding: 0 12px;
        vertical-align: middle;
        margin-right: 10px;
        position: relative;
        cursor: pointer;
        &:hover:not(.disabled){
            color: #00b5e2;
            border: solid 1px #00b5e2;
            background-color: rgba(0, 181, 226, 0.1);
        }
        &.pre-split{
            margin-left: 10px;
            &::before{
                content: "";
                width: 1px;
                height: 18px;
                background: #ebeef5;
                position: absolute;
                left: -11px;
                top: 9px;
                cursor: default;
            }
        }
        &.disabled{
            color: #696969;
            border: solid 1px #696969;
            cursor: default;
        }
    }
}
</style>